// https://git.huya.info/huyafed/components/huyafed-npm/-/tree/master/packages/taf-network
import TafNetwork from "@huyafed/taf-network/dist/taf-network.cjs.prod.js";
import { createTafRuntime, type TafTransport } from "@huyafed/gametool-taf-runtime";
import * as kiwiSdk from "@huyafed/huya-kiwi";
import { resolveTafRuntimeConfig } from './tafRuntimeConfig';

type TBase = {
  bcode: number;
  sdkcode: number;
  [key: string]: any;
};

const tafRuntimeConfig = resolveTafRuntimeConfig(import.meta.env, location.search);

export const tafSdk = new TafNetwork({
  showLog: tafRuntimeConfig.showLog,
  isDebug: tafRuntimeConfig.isDebug,
  tryTime: 10,
  kiwiSdk,
});

const tafRuntime = createTafRuntime({
  transport: tafSdk as unknown as TafTransport,
  timeoutMS: 10_000,
});

export const tafFetch = Object.assign(
  <TRsp = any, TReq = any>(params: {
    moduleName: string;
    funcName: string;
    ReqClass: new (...args: any) => any;
    RspClass: new (...args: any) => any;
    data: Partial<TReq>;
    timeoutMS?: number;
  }): Promise<TRsp & TBase> =>
    tafRuntime({
      ...params,
      data: params.data as Record<string, unknown>,
    } as Parameters<typeof tafRuntime>[0]) as Promise<TRsp & TBase>,
  { getTaf: tafRuntime.getTaf },
);

export default tafFetch;
